import { render, staticRenderFns } from "./RankChangeStudentConfirm.vue?vue&type=template&id=34795dd0&"
import script from "./RankChangeStudentConfirm.vue?vue&type=script&lang=js&"
export * from "./RankChangeStudentConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RankChangeStudentConfirm.vue?vue&type=style&index=0&id=34795dd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports